import React from "react";

const NotFound = props => (
  <div className='padded _bg viewport-height-100 col-center align-center '>
    <p className='txt-xl txt-center txt-bold -accent-alpha'>
      url not found <wbr/>
      <span className='-accent'>{props.location.pathname}</span>
    </p>
  </div>
);

export default NotFound;